import { yupResolver } from "@hookform/resolvers/yup";
import { FormControlLabel, Grid, Switch } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import FormWrapper from "src/components/FormWrapper";
import { FormProvider, RHFTextField } from "src/components/hook-form";
import { saveDocumentType } from "src/pages/api";
import * as Yup from "yup";

export default function AddDocumentType({ onClose, row, isEditMode }) {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    name: row?.name || "",
    isActive: isEditMode ? !!row?.isActive : true,
  };

  const schema = Yup.object().shape({
    name: Yup.string().trim().required("Document type name is required"),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const { handleSubmit, reset, control } = methods;

  const mutation = useMutation(
    (formData) =>
      saveDocumentType({ id: isEditMode ? row.id : undefined, req: formData }),
    {
      onSuccess: (response) => {
        enqueueSnackbar(
          isEditMode ? "Document type updated successfully" : "Document type created successfully",
          { variant: "success" }
        );
        queryClient.invalidateQueries(["document-types"]);
        onClose(response?.data);
      },
      onError: (error) => {
        const apiMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.response?.data?.details;
        enqueueSnackbar(apiMessage || error?.message || "Failed to save document type", {
          variant: "error",
        });
      },
    }
  );

  const onSubmit = (data) => {
    const payload = { name: data.name };
    if (isEditMode) payload.isActive = data.isActive;
    mutation.mutate(payload);
  };

  return (
    <FormWrapper
      title={isEditMode ? "Edit Document Type" : "Add Document Type"}
      onClose={onClose}
      onSubmit={handleSubmit(onSubmit)}
      onReset={() => reset(defaultValues)}
      loading={mutation.isLoading}
      isEditMode={isEditMode}
    >
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <RHFTextField name="name" required label="Document Type Name" autoFocus />
          </Grid>
          {isEditMode && (
            <Grid item xs={12}>
              <Controller
                name="isActive"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    control={<Switch checked={!!field.value} onChange={(e) => field.onChange(e.target.checked)} />}
                    label="Active"
                  />
                )}
              />
            </Grid>
          )}
        </Grid>
      </FormProvider>
    </FormWrapper>
  );
}
